<template>
  <div class="table-list">
    <el-table
      v-loading="loading"
      :data="data"
      style="width: 100%"
      :header-cell-style="{background:'#F4F7FA',color:'#606266'}"
      @select="handleSelect"
      @selection-change='handleSelection'
      @select-all="handleSelectAll"
      :max-height="height"
      :show-summary="showSummary"
      :sum-text="sumText"
      :row-class-name="tableRowClassName"
     >
        <el-table-column
        v-if="$scopedSlots.selection"
        type="selection"
        :selectable="selectable"
        fixed='left'
        width="55"/>
        <el-table-column
        v-if="$scopedSlots.index"
        type="index"
        :label="indexKey"
        width="100">
        <template v-slot='scoped'>
          <div>{{scoped.$index  + (page - 1) * pageSize + 1}}</div>
        </template>
        </el-table-column>
        <!-- :sortable='item.sortable || false' -->
        <el-table-column
          v-for="(item, index) in columnDefs"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width || null"
          :min-width="item.minWidth || 120"
          :fixed="item.prop === 'action'? 'right' : item.fixed ? item.fixed : false"
          :show-overflow-tooltip="item.showOverflowTooltip === false ? false : true"
          :formatter="item.formatter || null"
        >
          <template v-if="$scopedSlots[item.prop]" v-slot='scoped'>
            <slot :name="item.prop" v-bind="{row:scoped.row,index: scoped.$index}"></slot>
          </template>
          <template v-if="item.child">
             <el-table-column
              v-for="(items, ind) in item.child"
              :key="ind"
              :prop="items.prop"
              :label="items.label"
              :width="items.width || null"
              :min-width="items.minWidth || 120"
              :fixed="items.prop === 'action'? 'right' : item.fixed ? item.fixed : false"
              :show-overflow-tooltip="items.showOverflowTooltip === false ? false : true"
              :formatter="items.formatter || null"
            >
            <template v-if="$scopedSlots[items.prop]" v-slot='scoped'>
              <slot :name="items.prop" v-bind="{row:scoped.row,index: scoped.$index}"></slot>
            </template>
             </el-table-column>
          </template>
        </el-table-column>
    </el-table>
    <el-pagination
      v-if="showPagination"
      @current-change="pageChange"
      :current-page="page"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="total"
      class="paginationBody"/>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    data: {
      require: true,
      type: Array,
      default: () => []
    },
    columnDefs: {
      require: true,
      type: Array,
      default: () => []
    },
    page: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    height: {
      type: String
    },
    selectable: {
      type: Function,
      default: () => { return true }
    },
    showSummary: {
      type: Boolean,
      default: false
    },
    indexKey: {
      type: String,
      default: '序号'
    },
    sumText: {
      type: String,
      default: '合计'
    },
    tableRowClassName: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    pageChange (page) {
      this.$emit('pageChange', page)
    },
    handleSelect (selection, row) {
      this.$emit('select', selection, row)
    },
    handleSelectAll (selection) {
      this.$emit('select-all', selection)
    },
    handleSelection (row) {
      this.$emit('selection-change', row)
    }
  }
}
</script>

<style lang="scss" scoped>
.table-list {
  .paginationBody {
    margin-top: 0.1rem;
    text-align: center;
  }
}
</style>
